import React from 'react';
import { useParams } from 'react-router-dom';
import DSBox from '../../../design-system/DSBox';
import usePublicKlydoQuery from '../hooks/usePublicKlydoQuery';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import useResponsiveClockScale from '../hooks/useResponsiveClockScale';
import KlydoPreview from '../../../components/KlydoPlayer/Wrappers/KlydoPreview';
import { DSTypography } from '../../../design-system/Typography';
import usePublicKlydoView from '../hooks/usePublicKlydoView';
import { SHARE_PAGE_BACKGROUND } from '../../../consts/colors';

const commonBoxStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  backgroundColor: SHARE_PAGE_BACKGROUND,
  overflowX: 'hidden',
  overflowY: 'auto',
  boxSizing: 'border-box',
  padding: {
    xs: '8px 16px',
    sm: '40px',
    md: '60px',
  },
} as const;

const PublicKlydoView = () => {
  const { klydoId } = useParams<{ klydoId: string }>();

  const { data: klydo, isLoading, error } = usePublicKlydoQuery(klydoId || '');
  const scale = useResponsiveClockScale();

  const { menuButtonItemsList, isMuted, playSoundOnce, replaySoundTrigger } =
    usePublicKlydoView(
      klydo?.capabilitiesV2?.animationSound?.mode,
      !!klydo?.chimesUrls?.length,
      klydo?.chimesUrls?.[0],
    );

  if (isLoading) {
    return (
      <DSBox sx={commonBoxStyles}>
        <DSCircularProgress />
      </DSBox>
    );
  }

  if (error || !klydo) {
    return (
      <DSBox
        sx={{
          ...commonBoxStyles,
          color: '#FFFFFF',
          fontSize: {
            xs: '14px',
            sm: '16px',
          },
          textAlign: 'center',
        }}
      >
        <DSTypography>
          {error?.response?.data?.message ||
            error?.message ||
            'Klydo not found'}
        </DSTypography>
      </DSBox>
    );
  }

  return (
    <DSBox sx={commonBoxStyles}>
      <KlydoPreview
        klydo={klydo}
        scale={scale}
        backgroundHidden={false}
        dialsHidden
        showInfoTabs
        menuButtonItemsList={menuButtonItemsList}
        muted={isMuted}
        playSoundOnce={playSoundOnce}
        replaySoundTrigger={replaySoundTrigger}
        pendulumLogo={klydo.pendulumLogo || undefined}
      />
    </DSBox>
  );
};

export default PublicKlydoView;
